import { type AggRequest, type AggResponse, fetchAgg } from '../../../common/utils/fetch-agg';

import { type LoomSpaceNode } from './types';

const LOOM_SPACES_SEARCH_OPERATION_NAME = 'LoomRovoSpacesSearchQuery';
const loomSpacesSearchQuery = `
	query ${LOOM_SPACES_SEARCH_OPERATION_NAME}($siteId: ID!, $query: String) {
		loom_spacesSearch(siteId: $siteId, query: $query) {
			id
			name
			url
		}
	}
`;

export type LoomSpacesSearchQueryVariables = {
	siteId: string;
	query?: string;
	limit?: number;
};

export type LoomSpacesSearchQueryData = {
	loom_spacesSearch: LoomSpaceNode[];
};

export type LoomSearchEntitiesQueryProps = Pick<
	AggRequest<LoomSpacesSearchQueryVariables>,
	'aggAbsoluteUrl' | 'variables' | 'headers'
>;

const trimToLimit = (
	result: AggResponse<LoomSpacesSearchQueryData>,
	limit?: number,
): AggResponse<LoomSpacesSearchQueryData> =>
	typeof limit === 'number'
		? {
				...result,
				data: result.data
					? {
							...result.data,
							loom_spacesSearch: result.data.loom_spacesSearch.slice(0, limit),
						}
					: result.data,
			}
		: result;

export const loomSearchEntitiesQuery = async ({
	variables,
	aggAbsoluteUrl,
	headers,
}: LoomSearchEntitiesQueryProps): Promise<AggResponse<LoomSpacesSearchQueryData>> => {
	const { siteId, query, limit } = variables;
	const response = await fetchAgg<
		Pick<LoomSpacesSearchQueryVariables, 'siteId' | 'query'>,
		LoomSpacesSearchQueryData
	>({
		variables: { siteId, query },
		aggAbsoluteUrl,
		graphQuery: loomSpacesSearchQuery,
		operationName: LOOM_SPACES_SEARCH_OPERATION_NAME,
		headers,
	});

	return trimToLimit(response, limit);
};
